// extracted by mini-css-extract-plugin
module.exports = {"container":"about-marketplace_container__2BhWz","not-capitalize-text":"about-marketplace_not-capitalize-text__2fCk_"};